import { useNavigate } from 'react-router-dom';
import type { TrendingMarketDto } from '@/lib/models';

export interface TrendingContentProps {
  /** The trending/related markets to list (already fetched + ordered by the API). */
  markets: TrendingMarketDto[];
}

/**
 * Trending / related markets list ("People Are Also Trading", ARC-82 §5.4.5 /
 * ARC-161). Presentational: renders the ordered markets the API returned. The
 * fetch + hide-when-empty live in {@link TrendingSection} — this only draws rows.
 * Each row is a light card with a circular avatar and the market question,
 * tapping through to that market's event page.
 */
export function TrendingContent({ markets }: TrendingContentProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-2">
      {markets.map((m) => (
        <button
          key={m.marketId}
          type="button"
          disabled={!m.eventId}
          onClick={() => m.eventId && navigate(`/events/${m.eventId}`)}
          className="flex items-center gap-2.5 w-full rounded-[12px] bg-surface-soft px-3.5 py-1 text-left cursor-pointer disabled:cursor-default"
        >
          <span className="size-[49px] shrink-0 rounded-full bg-border" />
          <p className="text-sm font-medium text-ink line-clamp-2 m-0">{m.displayName ?? m.eventName ?? 'Market'}</p>
        </button>
      ))}
    </div>
  );
}
